import React, { useState } from 'react';
import api from '../services/api';
import { showToast } from '../utils/toast';

function ChangePasswordModal({ onClose }) {
  const [next, setNext] = useState('');
  const [confirm, setConfirm] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (next !== confirm) { showToast('As senhas não coincidem', 'error'); return; }
    if (next.length < 6) { showToast('A senha deve ter pelo menos 6 caracteres', 'warning'); return; }
    setLoading(true);
    try {
      await api.put('/users/profile/password', { password: next });
      showToast('Senha alterada com sucesso!', 'success');
      onClose();
    } catch (err) {
      showToast(err.response?.data?.message || 'Erro ao alterar senha', 'error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={e => e.stopPropagation()}>
        <h3>Trocar senha</h3>
        <form onSubmit={handleSubmit}>
          <div className="modal-body">
            <div className="modal-field">
              <label>Nova senha</label>
              <input
                type="password"
                value={next}
                onChange={e => setNext(e.target.value)}
                placeholder="Mínimo 6 caracteres"
                required
                minLength={6}
                autoFocus
              />
            </div>
            <div className="modal-field">
              <label>Confirmar nova senha</label>
              <input
                type="password"
                value={confirm}
                onChange={e => setConfirm(e.target.value)}
                placeholder="Repita a nova senha"
                required
              />
            </div>
          </div>
          <div className="modal-actions">
            <button type="button" className="btn-secondary" onClick={onClose}>Cancelar</button>
            <button type="submit" className="btn-primary" disabled={loading}>
              {loading ? 'Salvando...' : 'Salvar senha'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default ChangePasswordModal;
